<template>
    <div class="resident-profiles-table">
        <table id="forAT_table-ResidentProfilesEdit" class="common-table">
            <tr>
                <th class="resident-profiles-cell-number">
                    {{ $t('sensors.residentProfilesTab.table.columns.sensor') }}
                </th>
                <th class="resident-profiles-cell-type">
                    {{ $t('sensors.residentProfilesTab.table.columns.type') }}
                </th>
                <th class="resident-profiles-cell-chkbox">
                    {{ $t('sensors.residentProfilesTab.table.columns.enabled') }}
                </th>
                <th class="resident-profiles-cell-delay-time">
                    {{ $t('sensors.residentProfilesTab.table.columns.delayTime') }}
                </th>
                <th class="resident-profiles-cell-duration-time">
                    {{ $t('sensors.residentProfilesTab.table.columns.durationTime') }}
                </th>
            </tr>
            <tbody>
                <tr v-for="(sensor, index) in value" :key="index">
                    <td class="resident-profiles-cell-number">{{ sensor.no }}</td>
                    <td class="resident-profiles-cell-type">
                        <SelectBox
                            :value="sensor.type"
                            :options="select(sensor.no)"
                            style-class="inline"
                            :placeholder="$t('sensors.residentProfilesTab.typePlaceholder')"
                            @input="update(index, 'type', $event)"
                        />
                    </td>
                    <td class="resident-profiles-cell-chkbox">
                        <div class="chkbox">
                            <input
                                :id="sensorId + '-' + sensor.no"
                                type="checkbox"
                                :disabled="!sensor.type"
                                :checked="sensor.enabled"
                                @change="update(index, 'enabled', $event.target.checked)"
                            />
                            <label :for="sensorId + '-' + sensor.no"></label>
                        </div>
                    </td>
                    <td class="resident-profiles-cell-delay-time">
                        <div class="delay-time">
                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DelayTimeHH'"
                                :placeholder="$t('common.HH')"
                                :field="'delayHH' + index"
                                :value="sensor.delayTime.HH"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'delayTime', 'HH') }"
                                @input="
                                    update(index, 'delayTime', $event.target.value, 'HH') &&
                                        $v.value.$each[index].delayTime.HH.$touch()
                                "
                            />
                            <span v-show="!isSensorFieldValid(index, 'delayTime', 'HH')" class="tooltiptext">
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].delayTime.HH
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>

                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DelayTimeMM'"
                                :placeholder="$t('common.MM')"
                                :field="'delayMM' + index"
                                :value="sensor.delayTime.MM"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'delayTime', 'MM') }"
                                @input="
                                    update(index, 'delayTime', $event.target.value, 'MM') &&
                                        $v.value.$each[index].delayTime.MM.$touch()
                                "
                            />
                            <span v-show="!isSensorFieldValid(index, 'delayTime', 'MM')" class="tooltiptext">
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].delayTime.MM
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>

                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DelayTimeSS'"
                                :placeholder="$t('common.SS')"
                                :field="'delaySS' + index"
                                :value="sensor.delayTime.SS"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'delayTime', 'SS') }"
                                @input="
                                    update(index, 'delayTime', $event.target.value, 'SS') &&
                                        $v.value.$each[index].delayTime.SS.$touch()
                                "
                            />
                            <span v-show="!isSensorFieldValid(index, 'delayTime', 'SS')" class="tooltiptext">
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].delayTime.SS
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>
                        </div>
                    </td>
                    <td class="resident-profiles-cell-duration-time">
                        <div class="duration-time">
                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DurationTimeHH'"
                                :placeholder="$t('common.HH')"
                                :field="'durationHH' + index"
                                :value="sensor.durationTime.HH"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'durationTime', 'HH') }"
                                @input="
                                    update(index, 'durationTime', $event.target.value, 'HH') &&
                                        $v.value.$each[index].durationTime.HH.$touch()
                                "
                            />
                            <span
                                v-show="!isSensorFieldValid(index, 'durationTime', 'HH')"
                                class="tooltiptext"
                            >
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].durationTime.HH
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>

                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DurationTimeMM'"
                                :placeholder="$t('common.MM')"
                                :field="'durationMM' + index"
                                :value="sensor.durationTime.MM"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'durationTime', 'MM') }"
                                @input="
                                    update(index, 'durationTime', $event.target.value, 'MM') &&
                                        $v.value.$each[index].durationTime.MM.$touch()
                                "
                            />
                            <span
                                v-show="!isSensorFieldValid(index, 'durationTime', 'MM')"
                                class="tooltiptext"
                            >
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].durationTime.MM
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>

                            <input
                                :id="'forAT_' + sensorId + '-' + sensor.no + '_DurationTimeSS'"
                                :placeholder="$t('common.SS')"
                                :field="'durationSS' + index"
                                :value="sensor.durationTime.SS"
                                :disabled="!sensor.enabled || !sensor.type"
                                :class="{ tooltiperror: !isSensorFieldValid(index, 'durationTime', 'SS') }"
                                @input="
                                    update(index, 'durationTime', $event.target.value, 'SS') &&
                                        $v.value.$each[index].durationTime.SS.$touch()
                                "
                            />
                            <span
                                v-show="!isSensorFieldValid(index, 'durationTime', 'SS')"
                                class="tooltiptext"
                            >
                                <p
                                    v-for="(error, index2) in multipleErrorsDisplay(
                                        $v.value.$each[index].durationTime.SS
                                    )"
                                    :key="index2"
                                >
                                    {{ error }}
                                </p>
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script type="text/babel">
import SelectBox from '../../common/SelectBox.vue';
import { emptyAllFields, timeFormat, max24Hours, multipleErrorsDisplay } from '../../../validators';
import mappingState from '../../common/mappingState';

export default {
    components: {
        SelectBox,
    },

    mixins: [mappingState],

    props: {
        value: {
            type: Array,
            required: true,
        },

        sensorNames: {
            type: Array,
            required: true,
        },

        sensorId: {
            validator: prop => ['number', 'string', 'undefined'].includes(typeof prop),
            required: true,
        },
    },
    data() {
        return {};
    },

    validations() {
        return {
            value: {
                $each: {
                    $trackBy: 'no',
                    delayTime: {
                        HH: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'HH';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                        MM: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'MM';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                        SS: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'SS';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                    },
                    durationTime: {
                        HH: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'HH';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                        MM: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'MM';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                        SS: {
                            emptyAllFields,
                            timeFormat: (val, rule) => {
                                rule = 'SS';
                                return timeFormat(val, rule);
                            },
                            max24Hours,
                        },
                    },
                },
            },
        };
    },

    watch: {
        value: {
            handler() {
                this.setTableValid(this.areAllSensorsValid());
            },
            deep: true,
        },
    },

    methods: {
        multipleErrorsDisplay,

        areAllSensorsValid() {
            return !this.value.find((sensor, i) =>
                sensor.type && sensor.enabled ? this.$v.value.$each[i].$invalid : false
            );
        },

        isSensorFieldValid(i, field, time) {
            return (
                !this.value[i].type || !this.value[i].enabled || !this.$v.value.$each[i][field][time].$invalid
            );
        },

        /**
         * Emits updating list of sensors in parent component
         *
         * @param i - sensor's index
         * @param field - the field that will be updated
         * @param item - new data for the field
         * @param time - HH/MM/SS (for delay and duration update only)
         */
        update(i, field, item, time) {
            let val = [...this.value];
            val[i] = { ...val[i] };
            if (time) {
                val[i][field] = { ...val[i][field] };
                val[i][field][time] = item;
            } else {
                val[i][field] = item;
            }
            this.$emit('input', val);
        },

        select(no) {
            let names;
            switch (no) {
                case 1:
                    names = this.sensorNames.filter(
                        option =>
                            !option.value ||
                            ![this.value[1].type, this.value[2].type, this.value[3].type].includes(
                                option.value
                            )
                    );
                    break;
                case 2:
                    names = this.sensorNames.filter(
                        option =>
                            !option.value ||
                            ![this.value[0].type, this.value[2].type, this.value[3].type].includes(
                                option.value
                            )
                    );
                    break;
                case 3:
                    names = this.sensorNames.filter(
                        option =>
                            !option.value ||
                            ![this.value[0].type, this.value[1].type, this.value[3].type].includes(
                                option.value
                            )
                    );
                    break;
                case 4:
                    names = this.sensorNames.filter(
                        option =>
                            !option.value ||
                            ![this.value[0].type, this.value[1].type, this.value[2].type].includes(
                                option.value
                            )
                    );
                    break;
                default:
                    break;
            }

            return names;
        },
    },
};
</script>
